import { PeopleAlt } from '@mui/icons-material'

const clientIndex = {
  icon: PeopleAlt,
}

export default clientIndex
